module.exports = __webpack_public_path__ + "assets/img/order_7.b9cabe69.svg";